import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 30;

const slice = createSlice({
  name: 'deliveryTimeAsap',
  initialState,
  reducers: {
    setDeliveryTimeAsap(state, action: PayloadAction<number>) {
      return action.payload;
    },
  },
});

export const { setDeliveryTimeAsap } = slice.actions;

export default slice.reducer;
